import React from 'react';
import { navigate } from 'gatsby';
import styled from 'styled-components';

const ButtonStyles = styled.a`
  display: block;
  cursor: pointer;
  margin-bottom: 2rem;
  font-weight: 500;
  font-size: 2rem;
  &:before {
    content: '‹';
    font-size: 3rem;
    display: inline-block;
    text-decoration: none;
    margin-right: 10px;
  }

  &:hover {
    text-decoration: underline;
  }
`;
export default function BackButton({ customText, customLink }) {
  const hasNoBackParameter = typeof window !== 'undefined' && window.location.search.includes('no-back');

  if (hasNoBackParameter) {
    return null; // don't render the button at all if ?noback is present in the URL
  }

  return (
    <>
      {customLink ? (
        <ButtonStyles href={customLink} rel="nofollow">{customText || 'Back'}</ButtonStyles>
      ) : (
        <ButtonStyles onClick={() => navigate(-1)}>
          {customText || 'Back'}
        </ButtonStyles>
      )}
    </>
  );
}